import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from '../store';
import { authApi } from '../services/AuthService';
import { profilesApi } from '../services/ProfilesService';
import { AccessState, clearAdminData, validProjection } from '../../shared/access/access';
const initialState: AccessState = {
  profile: null, platformRoles: [], availableActions: [],
  accessStatus: 'loading', generation: 0,
};
const slice = createSlice({
  name: 'auth', initialState,
  reducers: {
    loggedOut: state => ({ ...initialState, generation: state.generation + 1, accessStatus: 'anonymous' }),
  },
  extraReducers: builder => {
    builder.addCase(clearAdminData, state => { state.generation += 1; });
    builder.addMatcher(authApi.endpoints.login.matchFulfilled, state => ({
      ...initialState, generation: state.generation + 1,
    }));
    builder.addMatcher(profilesApi.endpoints.getCurrentUserProfile.matchPending, (state, action) => {
      state.accessRequestId = action.meta.requestId;
      // A retry after error/expiry must not revive the retained profile's rights.
      state.accessStatus = state.accessStatus === 'ready' || state.accessStatus === 'refreshing' ? 'refreshing' : 'loading';
    });
    builder.addMatcher(profilesApi.endpoints.getCurrentUserProfile.matchFulfilled, (state, action) => {
      if (state.accessRequestId !== action.meta.requestId) return;
      if (!validProjection(action.payload)) { state.accessStatus = 'error'; return; }
      state.profile = action.payload.profile;
      state.platformRoles = action.payload.platformRoles;
      state.availableActions = action.payload.availableActions;
      state.accessStatus = 'ready';
    });
    builder.addMatcher(profilesApi.endpoints.getCurrentUserProfile.matchRejected, (state, action) => {
      if (state.accessRequestId !== action.meta.requestId) return;
      state.accessStatus = action.payload?.status === 401 ? 'anonymous' : 'error';
    });
    builder.addMatcher(authApi.endpoints.logout.matchFulfilled, state => ({
      ...initialState, generation: state.generation + 1, accessStatus: 'anonymous',
    }));
  },
});
export default slice.reducer;
export const selectCurrentProfile = (state: RootState) => state.auth.profile;
export const { loggedOut } = slice.actions;
